import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseV2PanelComponent } from './license-v2-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    LicenseV2PanelComponent],
  exports: [
    LicenseV2PanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class LicenseV2PanelModule { }
